import React from 'react';
import styles from './AlphaBar.module.css';

const AlphaBar = () => {
  return (
    <div className={styles.alphaBar}>
      {/* <p className={styles.alphaText}>Questa versione dell'applicazione è in fase alpha.</p> */}
    </div>
  );
};

export default AlphaBar;